import { FunctionComponent, useEffect, useRef } from 'react';
import ThreeDCardDemo from '../AceternityUI/3D-cardEffect/3d-cardComponent';
import styles from './section6.module.css';
import ThreeDCard2 from '../AceternityUI/3D-cardEffect/3d-card2';
import ThreeDCard3 from '../AceternityUI/3D-cardEffect/3d-card3';
import { useMediaQuery } from "@mui/material";


const Section6: FunctionComponent = () => {

	const isMobile = useMediaQuery("(max-width: 768px)");

	const linkParentRef = useRef<HTMLDivElement>(null);


	// useEffect(() => {
	// 	if (linkParentRef.current) {
	// 		const scrollWidth = linkParentRef.current.scrollWidth;
	// 		const scrollPosition = scrollWidth * 0.312;

	// 		linkParentRef.current.scrollLeft = scrollPosition;
	// 	}
	// }, []);

	return (
		<><div className={styles.efficientEffectiveComplianParent} style={{ marginTop: "380px" }}>
			<div className={styles.efficientEffectiveComplian} style={{ marginBottom: "-100px" }}>Efficient. Effective. Compliant.</div>
			<div className={styles.frameParent}>
				{/*<div className={styles.linkParent}>*/}
				<div className={styles.linkParent} ref={linkParentRef} style={{ overflowX: 'auto' }}>

					{isMobile && (
						<>
							<div style={{ transform: 'scale(0.8)', transformOrigin: 'top left',marginLeft:"-12px" }}>
								<ThreeDCardDemo />
							</div>
							<div style={{ transform: 'scale(0.8)', transformOrigin: 'top left' }}>
								<ThreeDCard2 />
							</div>
							<div style={{ transform: 'scale(0.8)', transformOrigin: 'top left',marginRight:"-72px" }}>
								<ThreeDCard3 />
							</div>
						</>
					)}
					{!isMobile && (
						<>
							<ThreeDCardDemo />
							<ThreeDCard2 />
							<ThreeDCard3 />
						</>
					)}

				</div>

			</div>
		</div>
		</>
	);
};

export default Section6;